"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "createApplicationContext", {
  enumerable: true,
  get: function get() {
    return _applicationContext.default;
  }
});
Object.defineProperty(exports, "createContextConfiguration", {
  enumerable: true,
  get: function get() {
    return _contextConfiguration.default;
  }
});
var _applicationContext = _interopRequireDefault(require("./application-context"));
var _contextConfiguration = _interopRequireDefault(require("./context-configuration"));
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NvbmZpZy9pbmRleC5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgY3JlYXRlQXBwbGljYXRpb25Db250ZXh0IGZyb20gJy4vYXBwbGljYXRpb24tY29udGV4dCc7XG5pbXBvcnQgY3JlYXRlQ29udGV4dENvbmZpZ3VyYXRpb24gZnJvbSAnLi9jb250ZXh0LWNvbmZpZ3VyYXRpb24nO1xuXG5leHBvcnQgeyBjcmVhdGVBcHBsaWNhdGlvbkNvbnRleHQsIGNyZWF0ZUNvbnRleHRDb25maWd1cmF0aW9uIH07XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBO0FBQ0E7QUFBaUU7RUFBQTtBQUFBIn0=